type Props = {
  children: JSX.Element,
  isLoading?: boolean,
  className?: string
};

function Card({children, isLoading = false, className = ''}: Props) {
  
  return (
    <div className={`flex flex-col flex-wrap p-5 w-full animate-fade-in-up rounded-lg border bg-card text-card-foreground shadow-sm ${className}`}>
      { isLoading ?
        Array.apply(null, Array(1))
          .map((m, i) => <div key={i} className="shadow p-5 w-full mx-auto animate-pulse"></div>) 
        :
       children }
    </div>
  );
}

export default Card;
